import { DEX_TYPE } from "@/config/constants";
import { getEnvAndDex } from "@/utils/get-env-and-dex";

export const useTradex = () =>{
	const { dex } = getEnvAndDex();

	const isTradex = DEX_TYPE.SGTRADEX === dex;
	return isTradex;
}


